/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  PaginatedRiskCategoryList,
  PaginatedRiskList,
  PatchedRisk,
  PatchedRiskCategoryWrite,
  Risk,
  RiskCategory,
  RiskCategoryWrite,
} from '../models/index';
import {
  PaginatedRiskCategoryListFromJSON,
  PaginatedRiskCategoryListToJSON,
  PaginatedRiskListFromJSON,
  PaginatedRiskListToJSON,
  PatchedRiskFromJSON,
  PatchedRiskToJSON,
  PatchedRiskCategoryWriteFromJSON,
  PatchedRiskCategoryWriteToJSON,
  RiskFromJSON,
  RiskToJSON,
  RiskCategoryFromJSON,
  RiskCategoryToJSON,
  RiskCategoryWriteFromJSON,
  RiskCategoryWriteToJSON,
} from '../models/index';

export interface ApiRiskCategoriesCreateRequest {
  riskCategoryWrite: RiskCategoryWrite;
}

export interface ApiRiskCategoriesDestroyRequest {
  id: number;
}

export interface ApiRiskCategoriesListRequest {
  page?: number;
}

export interface ApiRiskCategoriesPartialUpdateRequest {
  id: number;
  patchedRiskCategoryWrite?: PatchedRiskCategoryWrite;
}

export interface ApiRiskCategoriesRetrieveRequest {
  id: number;
}

export interface ApiRiskCategoriesUpdateRequest {
  id: number;
  riskCategoryWrite: RiskCategoryWrite;
}

export interface ApiRisksCreateRequest {
  risk: Omit<Risk, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt' | 'categories'>;
}

export interface ApiRisksDestroyRequest {
  id: number;
}

export interface ApiRisksListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiRisksPartialUpdateRequest {
  id: number;
  patchedRisk?: Omit<PatchedRisk, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt' | 'categories'>;
}

export interface ApiRisksRetrieveRequest {
  id: number;
}

export interface ApiRisksUpdateRequest {
  id: number;
  risk: Omit<Risk, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt' | 'categories'>;
}

/**
 *
 */
export class RiskApi extends runtime.BaseAPI {
  /**
   */
  async apiRiskCategoriesCreateRaw(
    requestParameters: ApiRiskCategoriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskCategoryWrite>> {
    if (requestParameters['riskCategoryWrite'] == null) {
      throw new runtime.RequiredError(
        'riskCategoryWrite',
        'Required parameter "riskCategoryWrite" was null or undefined when calling apiRiskCategoriesCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_categories/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RiskCategoryWriteToJSON(requestParameters['riskCategoryWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskCategoryWriteFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskCategoriesCreate(
    requestParameters: ApiRiskCategoriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskCategoryWrite> {
    const response = await this.apiRiskCategoriesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskCategoriesDestroyRaw(
    requestParameters: ApiRiskCategoriesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskCategoriesDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_categories/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiRiskCategoriesDestroy(
    requestParameters: ApiRiskCategoriesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiRiskCategoriesDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async apiRiskCategoriesListRaw(
    requestParameters: ApiRiskCategoriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskCategoryList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_categories/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskCategoryListFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskCategoriesList(
    requestParameters: ApiRiskCategoriesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskCategoryList> {
    const response = await this.apiRiskCategoriesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskCategoriesPartialUpdateRaw(
    requestParameters: ApiRiskCategoriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskCategoryWrite>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskCategoriesPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_categories/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedRiskCategoryWriteToJSON(requestParameters['patchedRiskCategoryWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskCategoryWriteFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskCategoriesPartialUpdate(
    requestParameters: ApiRiskCategoriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskCategoryWrite> {
    const response = await this.apiRiskCategoriesPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskCategoriesRetrieveRaw(
    requestParameters: ApiRiskCategoriesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskCategory>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskCategoriesRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_categories/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskCategoryFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskCategoriesRetrieve(
    requestParameters: ApiRiskCategoriesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskCategory> {
    const response = await this.apiRiskCategoriesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskCategoriesUpdateRaw(
    requestParameters: ApiRiskCategoriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskCategoryWrite>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskCategoriesUpdate().',
      );
    }

    if (requestParameters['riskCategoryWrite'] == null) {
      throw new runtime.RequiredError(
        'riskCategoryWrite',
        'Required parameter "riskCategoryWrite" was null or undefined when calling apiRiskCategoriesUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_categories/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RiskCategoryWriteToJSON(requestParameters['riskCategoryWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskCategoryWriteFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskCategoriesUpdate(
    requestParameters: ApiRiskCategoriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskCategoryWrite> {
    const response = await this.apiRiskCategoriesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRisksCreateRaw(
    requestParameters: ApiRisksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Risk>> {
    if (requestParameters['risk'] == null) {
      throw new runtime.RequiredError(
        'risk',
        'Required parameter "risk" was null or undefined when calling apiRisksCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risks/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RiskToJSON(requestParameters['risk']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskFromJSON(jsonValue));
  }

  /**
   */
  async apiRisksCreate(
    requestParameters: ApiRisksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Risk> {
    const response = await this.apiRisksCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRisksDestroyRaw(
    requestParameters: ApiRisksDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRisksDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiRisksDestroy(
    requestParameters: ApiRisksDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiRisksDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async apiRisksListRaw(
    requestParameters: ApiRisksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risks/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskListFromJSON(jsonValue));
  }

  /**
   */
  async apiRisksList(
    requestParameters: ApiRisksListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskList> {
    const response = await this.apiRisksListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRisksPartialUpdateRaw(
    requestParameters: ApiRisksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Risk>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRisksPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedRiskToJSON(requestParameters['patchedRisk']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskFromJSON(jsonValue));
  }

  /**
   */
  async apiRisksPartialUpdate(
    requestParameters: ApiRisksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Risk> {
    const response = await this.apiRisksPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRisksRetrieveRaw(
    requestParameters: ApiRisksRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Risk>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRisksRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskFromJSON(jsonValue));
  }

  /**
   */
  async apiRisksRetrieve(
    requestParameters: ApiRisksRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Risk> {
    const response = await this.apiRisksRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRisksUpdateRaw(
    requestParameters: ApiRisksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Risk>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRisksUpdate().',
      );
    }

    if (requestParameters['risk'] == null) {
      throw new runtime.RequiredError(
        'risk',
        'Required parameter "risk" was null or undefined when calling apiRisksUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RiskToJSON(requestParameters['risk']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskFromJSON(jsonValue));
  }

  /**
   */
  async apiRisksUpdate(
    requestParameters: ApiRisksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Risk> {
    const response = await this.apiRisksUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
